const featuredItems = [
  {
    title: 'Best Sneakers Under $100',
    desc: 'Complete price comparison across top suppliers',
    categoryName: 'Shoes',
    categoryUrl: 'https://kaspreadsheet.com/category-911-Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Single%20premium%20running%20sneaker%20suspended%20mid-air%20by%20invisible%20thread%20against%20gradient%20sunset%20orange%20backdrop%20dramatic%20studio%20lighting%20frozen%20motion%20dynamic%20energy%20bold%20color%20contrast%20high-speed%20photography%20commercial%20quality%20striking%20visual&width=800&height=1000&seq=trend-v2-sneakers&orientation=portrait',
  },
  {
    title: 'Top-Rated Hoodies 2026',
    desc: 'Quality scores and shipping time analysis',
    categoryName: 'Hoodies/Sweaters',
    categoryUrl: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Person%20wearing%20cozy%20oversized%20hoodie%20from%20behind%20walking%20through%20autumn%20park%20golden%20leaves%20scattered%20warm%20backlighting%20creating%20halo%20effect%20nostalgic%20fall%20atmosphere%20lifestyle%20editorial%20rich%20golden%20and%20amber%20tones&width=800&height=1000&seq=trend-v2-hoodies&orientation=portrait',
  },
  {
    title: 'Accessory Value Picks',
    desc: 'Best bang-for-buck accessories ranked',
    categoryName: 'Accessories',
    categoryUrl: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Hand%20holding%20stylish%20minimalist%20sunglasses%20against%20bright%20blue%20sky%20with%20fluffy%20white%20clouds%20summer%20vibe%20fresh%20outdoor%20lifestyle%20looking%20upward%20perspective%20clean%20crisp%20editorial%20fashion%20photography%20vibrant%20natural%20light&width=800&height=1000&seq=trend-v2-accessories&orientation=portrait',
  },
];

export default function TrendingSection() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="mb-12">
          <h2 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-950">
            <span className="inline-block mr-3">
              <i className="ri-fire-line text-secondary-500"></i>
            </span>
            Trending Product Sheets
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {featuredItems.map((item) => (
            <a
              key={item.imageUrl}
              href={item.categoryUrl}
              target="_blank"
              rel="noopener nofollow"
              className="group block cursor-pointer"
            >
              <div className="relative rounded-lg overflow-hidden h-80 md:h-96 bg-background-100">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  title={`${item.title} - PandabuySpreadsheet`}
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/10 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-5">
                  <span className="inline-block px-3 py-1 rounded-full bg-accent-400/85 text-background-50 text-xs font-medium mb-3">
                    {item.categoryName}
                  </span>
                  <h3 className="font-heading text-lg md:text-xl font-semibold text-background-50 mb-2">
                    {item.title}
                  </h3>
                  <p className="text-background-50/75 text-sm">{item.desc}</p>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}